import { selectorParser } from './selectorParser';
export function classNameFromVNode(vNode) {
  var _a = selectorParser(vNode).className,
      cn = _a === void 0 ? '' : _a;

  if (!vNode.data) {
    return cn;
  }

  var _b = vNode.data,
      dataClass = _b.class,
      props = _b.props;

  if (dataClass) {
    var c = Object.keys(dataClass).filter(function (cl) {
      return dataClass[cl];
    });
    cn += " " + c.join(" ");
  }

  if (props && props.className) {
    cn += " " + props.className;
  }

  return cn && cn.trim();
}